import React from 'react';
import './PetAnimations.css';

export default function DuckParadeSvg({ size = 120, color, className = '' }) {
  const mama = color || '#F4C033';
  const mamaShade = '#D9A11C';
  const baby = '#FFE070';
  const babyShade = '#E8C448';
  const beak = '#F2872B';
  const beakDark = '#C56A18';

  const eye = (cx, cy, r = 1.6) => (
    <g>
      <circle cx={cx} cy={cy} r={r} fill="#2C2419" />
      <circle cx={cx + 0.4} cy={cy - 0.4} r={r * 0.4} fill="white" />
    </g>
  );

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Water line */}
      <ellipse cx="60" cy="98" rx="50" ry="4" fill="#B8D8F0" opacity="0.5" />
      <path d="M14 96C22 94 30 96 38 94" stroke="#B8D8F0" strokeWidth="1" fill="none" opacity="0.6" />
      <path d="M82 96C90 94 98 96 106 94" stroke="#B8D8F0" strokeWidth="1" fill="none" opacity="0.6" />

      {/* Mama duck (back / largest) */}
      <ellipse cx="78" cy="72" rx="22" ry="16" fill={mama} />
      <ellipse cx="78" cy="74" rx="14" ry="10" fill={mamaShade} opacity="0.4" />
      {/* Mama tail tuft */}
      <path d="M98 64L106 56L100 70Z" fill={mama} />
      {/* Mama head */}
      <circle cx="58" cy="56" r="13" fill={mama} />
      {/* Mama beak */}
      <ellipse cx="46" cy="58" rx="6" ry="3.5" fill={beak} />
      <line x1="46" y1="58" x2="52" y2="58" stroke={beakDark} strokeWidth="0.5" />
      {/* Mama eye */}
      {eye(60, 53, 2)}
      {/* Mama feet hint */}
      <path d="M70 88L68 92" stroke={beak} strokeWidth="2" strokeLinecap="round" />
      <path d="M82 88L84 92" stroke={beak} strokeWidth="2" strokeLinecap="round" />

      {/* Duckling 1 (middle) */}
      <ellipse cx="38" cy="84" rx="10" ry="7" fill={baby} />
      <ellipse cx="38" cy="86" rx="6" ry="4" fill={babyShade} opacity="0.4" />
      <circle cx="30" cy="78" r="6" fill={baby} />
      <ellipse cx="24" cy="79" rx="3" ry="2" fill={beak} />
      {eye(28, 77, 1.2)}

      {/* Duckling 2 (front, smaller) */}
      <ellipse cx="18" cy="90" rx="8" ry="5.5" fill={baby} />
      <circle cx="13" cy="86" r="5" fill={baby} />
      <ellipse cx="8" cy="87" rx="2.5" ry="1.8" fill={beak} />
      {eye(11, 85, 1)}

      {/* Tiny ripple */}
      <path d="M16 96L24 96M28 98L36 98" stroke="#88B8D0" strokeWidth="0.6" strokeLinecap="round" />
    </svg>
  );
}
